export const PreEx6Columns = [
	{
		label: 'Year',
		field: 'qualificationYear',
		align: 'left'
	},
	{
		label: 'Type',
		field: 'type',
		align: 'left'
	},
	{
		label: 'Title',
		field: 'title',
		align: 'left'
	},
	{
		label: 'Code',
		field: 'markingTeamCode',
		align: 'left'
	},
	{
		label: 'Appointees',
		field: 'appointees',
		align: 'center'
	},
	{
		label: 'Actions',
		field: 'actions',
		align: 'center'
	}
];
